import endpointConfig from "../configs/endpoint.config"
import httpConfig from "../configs/http.config"
import { MenuPrivilegeServicePayloadProps, MenuPrivilegeServiceResponseProps } from "../types/menu-privilege.type"

const menuPrivilegeService = {
  list: async function(body: MenuPrivilegeServicePayloadProps) {
    const response = await httpConfig().post<MenuPrivilegeServiceResponseProps>(endpointConfig.menuPrivilege.list, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  }
}

export default menuPrivilegeService